import { useParams } from "react-router-dom";
import { services } from "../data/services";
import SEO from "../components/common/SEO";
import PageNotFound from "./PageNotFound";
import HeroWhyChoose from "../components/common/HeroWhyChoose";
import ContactFormSection from "../components/contact/ContactFormSection";
import CTASection from "../components/common/CTASection";
import ServiceBanner from "../components/servicedetails/ServiceBanner";
import ServiceOverview from "../components/servicedetails/ServiceOverview";
import ServiceFeatures from "../components/servicedetails/ServiceFeatures";
import ServiceBenefits from "../components/servicedetails/ServiceBenefits";
import ServiceProcess from "../components/servicedetails/ServiceProcess";
import ServiceFaq from "../components/servicedetails/ServiceFaq";
import ServiceProjects from "../components/servicedetails/ServiceProjects";

const ServiceDetails = () => {
  const { slug } = useParams();

  const service = services.find(
    (item) => item.slug === slug
  );

  if (!service) {
    return <PageNotFound />;
  }

  return (
    <>
      <SEO
        title={service.metaTitle || `${service.title} | AZ Construction Indore`}
        description={service.metaDescription || service.shortDescription}
        url={`https://azconstruction.com/services/${service.slug}`}
        image={service.image}
      />
      <ServiceBanner service={service} />

      <ServiceOverview service={service} />

      <ServiceFeatures service={service} />

      <ServiceBenefits service={service} />

      <ServiceProcess service={service} />

      <HeroWhyChoose />

      <ServiceProjects service={service} />

      <ServiceFaq service={service} />

      <ContactFormSection />

      <CTASection />
    </>
  );
};

export default ServiceDetails;